export default function NewSyncableBatchChangeDirective() {
  return {
    template: require('./new-syncable-batch-change.html'),
    restrict: 'E',
    controller: 'NewSyncableBatchChangeController',
    controllerAs: 'newSyncableBatchChangeVM',
    bindToController: true,
    replace: true,
    scope: {
      change: '=',
      isNew: '=',
      ssTooltipAppendToSelector: '@',
      handleApproveChangeClick: '&',
      handleDenyChangeClick: '&',
    },
  };
}
